import React, { useState } from "react";
import { Modal, Input, notification, Form } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getError } from "../../utils/form";

const { TextArea } = Input;

const schema = yup.object().shape({
  mainConcern: yup.string().required("Field can't be empty"),
  description: yup.string().required("Field can't be empty"),
});

const openNotification = () => {
  notification.success({
    message: "Success!",
    description:
      "Your concern is shared with our team. An Admin will get back to your with resolution.",
    onClick: () => {
      console.log("Notification Clicked!");
    },
  });
};

const ControlledInput = ({
  control,
  errors,
  name,
  label,
  required,
  setConcernError,
}) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          required={required}
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Input
            {...field}
            onFocus={() => {
              setConcernError(false);
            }}
          />
        </Form.Item>
      )}
    />
  );
};

const ControlledTextArea = ({
  control,
  errors,
  name,
  label,
  required,
  setDescriptionError,
}) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          required={required}
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <TextArea
            rows={4}
            {...field}
            onFocus={() => {
              setDescriptionError(false);
            }}
          />
        </Form.Item>
      )}
    />
  );
};

const RaiseDisputeForm = ({ visible, setVisible, onSave, loading }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      mainConcern: "",
      description: "",
    },
    resolver: yupResolver(schema),
  });

  const [concernError, setConcernError] = useState(null);
  const [descriptionError, setDescriptionError] = useState(null);

  const handleSuccess = () => {
    reset();
    setVisible(false);
    openNotification();
  };

  const handleFailure = () => {
    notification.error({
      message: "Failure!!",
      description: "There was some error",
    });
  };

  const onSubmit = (data) => {
    if (data.mainConcern.trim().length === 0) setConcernError(true);
    else if (data.description.trim().length === 0) setDescriptionError(true);
    else {
      const payloadData = {
        mainConcern: data.mainConcern,
        description: data.description,
      };
      const payload = {
        onSuccess: handleSuccess,
        data: payloadData,
        onFailure: handleFailure,
      };
      onSave(payload);
    }
  };

  const handleCancel = () => {
    reset();
    setVisible(false);
    setConcernError(false);
    setDescriptionError(false);
  };

  return (
    <Modal
      title="Raise Dispute"
      visible={visible}
      okText="Submit"
      okButtonProps={{ loading: loading }}
      onOk={handleSubmit(onSubmit)}
      onCancel={handleCancel}
    >
      <p style={{ fontWeight: "500", fontSize: "14px" }}>Main Concern:</p>
      <ControlledInput
        required={true}
        name="mainConcern"
        errors={errors}
        control={control}
        setConcernError={setConcernError}
      />
      {concernError && (
        <p style={{ color: "red", fontSize: "14px" }}>Please add Concern</p>
      )}
      <p style={{ marginTop: "10px", fontWeight: "500", fontSize: "14px" }}>
        Description:
      </p>
      <ControlledTextArea
        required={true}
        name="description"
        errors={errors}
        control={control}
        setDescriptionError={setDescriptionError}
      />
      {descriptionError && (
        <p style={{ color: "red", fontSize: "14px" }}>Please add Description</p>
      )}
    </Modal>
  );
};

export default RaiseDisputeForm;
